var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:(_vm.styles)},[_vm._t("body",function(){return [_vm._v(" "+_vm._s(_vm.nameHiddenIfDelay)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }